import z from 'zod';
import { integerIdValidator } from '../../utils/common';
export const EducationLevelSchema = z
    .object({
    id: integerIdValidator.optional(),
    name: z.string().min(1).max(255).optional()
})
    .describe('Education Level object with id and name');
//# sourceMappingURL=educationLevelSchema.js.map